<script setup>
import img2 from '@/assets/app_client/MOCKUPWEB_310_whats_sense_ratlla.png'
</script>
<template>
  <img :src="img2" loading="lazy" />
</template>
